import React, { useEffect, useState, useRef } from 'react';
import IkIslemleriAPI, { PerAileDurumBilgiListRequest } from '../../../apis/IkIslemleriAPI';
import TableComponent from "../../../components/OB/TableComponent";

interface AileDurumBilgileriProps {
    rfPerSicilBilgi: number;
}

const AileDurumBilgileri: React.FC<AileDurumBilgileriProps> = ({ rfPerSicilBilgi }) => {
    const [aileDurumList, setAileDurumList] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    // API istek kontrolü - aynı anda birden fazla istek engelleme
    const isLoadingRef = useRef(false);
    // Son yüklenen sicilId - gereksiz tekrar yüklemeyi önle
    const lastLoadedSicilRef = useRef<number | null>(null);

    const columns = [
        { header: "TC Kimlik No", field: "qtTcKimlikNo", className: "text-center" },
        { header: "Adı", field: "chAdi", className: "text-center" },
        { header: "Soyadı", field: "chSoyadi", className: "text-center" },
        { header: "Yakınlık", field: "ctYakinlikDerecesiAdi", className: "text-center" },
        { header: "Cinsiyet", field: "rfLpCinsiyetAdi", className: "text-center" },
        { header: "Doğum Tarihi", field: "dtDogumTarihi", className: "text-center" },
        { header: "Bitiş Tarihi", field: "dtBitisTarihi", className: "text-center" },
    ];

    const formatDate = (dateString: any): string => {
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return "Bilgi Yok";
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear();
            return `${day}.${month}.${year}`;
        } catch {
            return "Bilgi Yok";
        }
    };

    useEffect(() => {
        const fetchAileDurumBilgileri = async () => {
            // Rate limiting kontrolü - aynı istek devam ediyorsa veya aynı sicil zaten yüklendiyse çık
            if (isLoadingRef.current) {
                return;
            }
            if (lastLoadedSicilRef.current === rfPerSicilBilgi && aileDurumList.length > 0) {
                return;
            }

            if (!rfPerSicilBilgi) {
                setError("Per Sicil Bilgi ID mevcut değil.");
                setLoading(false);
                return;
            }
            try {
                isLoadingRef.current = true;
                setLoading(true);
                const request: PerAileDurumBilgiListRequest = {
                    rfPerSicilBilgi: rfPerSicilBilgi //10
                };
                const response = await IkIslemleriAPI.perAileDurumBilgiList(request);
                if (response && response.data) {
                    const formattedData = response.data.map((item: any) => ({
                        ...item,
                        dtDogumTarihi: formatDate(item.dtDogumTarihi),
                        dtBitisTarihi: formatDate(item.dtBitisTarihi)
                    }));
                    setAileDurumList(formattedData);
                    lastLoadedSicilRef.current = rfPerSicilBilgi;
                } else {
                    setAileDurumList([]);
                }
            } catch (err: any) {
                setError("Veri çekilirken bir hata oluştu: " + (err?.message ?? err));
                console.error("Aile Durum Bilgileri Listesi Hatası:", err);
            } finally {
                isLoadingRef.current = false;
                setLoading(false);
            }
        };
        fetchAileDurumBilgileri();
    }, [rfPerSicilBilgi]);

    const colCount = 7;

    return (
        <TableComponent 
            columns={columns} 
            data={aileDurumList} 
            recordsPerPage={12}
        />
    );
};

export default AileDurumBilgileri;
